export default {
	articles: "Articles",
	orders: "Order History",
	cart: "Cart",
	account: "Account",
	settings: "Settings",
	manageUsers: "Manage users",
	logout: "Log out",
	hide: "Hide",
	privateAccount: "Private account (Customer number: {customerId})",
	companyAccount: "{companyName} (Customer number: {customerId})",
	footer: {
		materials: "Materials",
		materialsTooltip: "List of available materials",
		privacy: "Privacy",
		privacyTooltip: "Privacy policy",
		terms: "Terms",
		termsTooltip: "Blexon's general terms and conditions",
		imprint: "Imprint",
		imprintTooltip: "Imprint",
		languageTooltip: "Change your language in the account settings",
	},
};
